import { AnswerModel, interstitialAnswer } from '@/components/decision-tree/hooks';
import { TOAST_DEFAULT_OPTIONS } from '@/constants/toast';
import { getInterstitialImageId } from '@/utils';
import { useBreakpointValue, useToast } from '@cmpsr/components';
import { useEffect, useState } from 'react';
import { InfoImageInterstitialType } from './types';

export const useInfoImageInterstitialController = ({
  saveAnswer,
  data,
  goToNextSurveyItem,
}: {
  saveAnswer: (answer: AnswerModel) => void;
  data: InfoImageInterstitialType;
  goToNextSurveyItem: () => void;
}) => {
  const [lastAnswered, setlastAnswered] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const toast = useToast();

  useEffect(() => {
    if (lastAnswered !== data.id) {
      setlastAnswered(data.id);
      saveAnswer(interstitialAnswer);
    }
  }, [data.id]);

  const imageId = getInterstitialImageId(data.resource, 'info');

  const handleNextClick = async () => {
    setIsLoading(true);
    try {
      await goToNextSurveyItem();
    } catch (error) {
      toast({
        ...TOAST_DEFAULT_OPTIONS,
        title: 'Error',
        description: error,
        status: 'error',
      });
      setIsLoading(false);
    }
    setIsLoading(false);
  };

  const buttonLabel = useBreakpointValue({ base: "Let's Go", md: 'Continue' }, { ssr: false });

  return {
    title: data.title,
    subtitle: data.subtitle,
    text: data.text,
    imageId,
    handleNextClick,
    isLoading,
    buttonLabel,
  };
};
